import queryClient from '../../queryClient'
import {
  TIME_ENTRIES_QUERY_KEY,
  TIMESHEETS_QUERY_KEY,
  TIME_OFF_ENTRIES_QUERY_KEY,
} from '../queries/keys'

const filters = { queryKey: TIME_ENTRIES_QUERY_KEY }

const mapEntries = fn =>
  queryClient.setQueriesData(filters, old => (Array.isArray(old) ? fn(old) : old))

export const cancelPending = () => {
  queryClient.cancelQueries(filters)
}

export const addEntry = entry => mapEntries(entries => [...entries, entry])

export const replaceEntry = (entryId, entry) =>
  mapEntries(entries => entries.map(e => (e._id === entryId ? entry : e)))

export const patchEntry = (entryId, patch) =>
  mapEntries(entries => entries.map(e => (e._id === entryId ? { ...e, ...patch } : e)))

export const removeEntry = entryId => mapEntries(entries => entries.filter(e => e._id !== entryId))

export const findEntry = entryId =>
  queryClient
    .getQueriesData(filters)
    .flatMap(([, data]) => (Array.isArray(data) ? data : []))
    .find(e => e._id === entryId)

export const restoreEntry = (entryId, previousEntry) =>
  previousEntry ? replaceEntry(entryId, previousEntry) : undefined

export const invalidate = () => queryClient.invalidateQueries(filters)

export const invalidateAfterDelete = () =>
  Promise.all([
    queryClient.invalidateQueries(filters),
    queryClient.invalidateQueries({ queryKey: TIMESHEETS_QUERY_KEY }),
    queryClient.invalidateQueries({ queryKey: TIME_OFF_ENTRIES_QUERY_KEY }),
  ])
